import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { FryCommonModule } from '@fry/components/common';
import { EasFormModule } from '@fry/components/common/easform/easform.module';
import { MaterialModule } from '@fry/components/material';
import { PaymentsModule } from '@fry/payments/payments.module';
import { UnboxedModule } from '@fry/ui';
import { UIBadgeModule } from '@fry/ui/badge';

import { BookingRoutingModule } from './booking-routing.module';
import { bookingTypesComponents } from '../components/booking-types';
import { bookingItemsComponents } from '../components/booking-items';
import { venuesComponents } from '../components/venues';
import { bookingsComponents } from '../components/bookings/components';
import { BookingWorkflowModule } from '../lib/bookings/workflow/workflow.module';
import { BookingItemEditorModule } from '../booking-item-editor';
import { EligibilityEditorModule } from '../eligibility-editor';
import { TranslationEditorModule } from '../translation-editor';
import { InteractiveTableModule } from '@fry/components/common/list/interactive-table';
import { ConnectionsModule } from "@fry/connections/app";
import { FixedDataTableModule } from '@fry/components/common/fixed-data-table/fixed-data-table.module';
import { BookingAvailableListComponent } from '../components/bookings/booking-available-items/booking-available-list.component';
import { EligibilityViewComponent } from '../components/bookings/eligibility-view/eligibility-view.compoent';
import { EligibilityViewRuleComponent } from '../components/bookings/eligibility-view/eligibility-view-rule.component';


@NgModule({
  imports: [
    ReactiveFormsModule,
    EasFormModule,
    BookingRoutingModule,
    CommonModule,
    MaterialModule,
    FryCommonModule,
    UnboxedModule,
    UIBadgeModule,
    BookingWorkflowModule.forRoot(),
    PaymentsModule,
    BookingItemEditorModule,
    EligibilityEditorModule,
    TranslationEditorModule,
    InteractiveTableModule,
    FixedDataTableModule,
    BookingAvailableListComponent,
    EligibilityViewComponent,
    EligibilityViewRuleComponent,
    ConnectionsModule
  ],
  declarations: [
    ...bookingTypesComponents,
    ...bookingItemsComponents,
    ...bookingsComponents,
    ...venuesComponents
  ]
})
export class BookingModule {
}
